<template>
  <div>
    <label for="shippingCountries">{{ $translate("Servershop5::Template.switchShippingCountry") }}</label>
    <template>
      <select id="shippingCountries" v-if="localization.shippingCountries.length > 1" class=" selectLangCurrCountry" @change="setShippingCountry($event.target.value)">
        <option v-for="shippingCountry in localization.shippingCountries"
                :value="shippingCountry.id"
                :disabled="isDisabled"
                :selected="basket.shippingCountryId == shippingCountry.id"
                :key="shippingCountry.id">
          {{shippingCountry.currLangName}}
        </option>
      </select>
      <div v-else>
       <span class="h3">
        {{ getCountryName(localization.shippingCountryId) }}
       </span>
      </div>
    </template>
  </div>
</template>

<script>
import { removeUrlParam } from "../services/UrlService";
import { mapState, mapGetters } from "vuex";
import ApiService from "../services/ApiService";

export default {
  computed:
      {
        isDisabled()
        {
          return !!this.basket.customerInvoiceAddressId || !!this.basket.customerShippingAddressId
        },

        ...mapState({
          localization: state => state.localization,
          basket: state => state.basket.data
        }),

        ...mapGetters([
          "getCountryName"
        ])
      },

  mounted()
  {
    removeUrlParam("openBasketPreview");
  },
  methods:
      {

        setShippingCountry(id) {
          // Emit the selectedId to the parent
          this.$emit("updateShippingCountryId", id);
        }
      }
}
</script>
